import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { ListGroupItem } from './ListGroupItem';
const ListGroupComponent = ({ children, className }) => (_jsx("div", { className: classNames('list-none rounded-lg border border-gray-200 bg-white text-sm font-medium text-gray-900 dark:border-gray-600 dark:bg-gray-700 dark:text-white', className), children: children }));
ListGroupComponent.displayName = 'ListGroup';
ListGroupItem.displayName = 'ListGroup.Item';
export const ListGroup = Object.assign(ListGroupComponent, { Item: ListGroupItem });
